export const MARKETS_DATA = [
    {
        id: 1,
        title: "Will Bitcoin hit $100k before Q4 2026?",
        source: "Polymarket",
        long: 68,
        short: 32,
        volume: "548.3M",
        image: "/assets/markets/crypto.png",
        category: "Crypto"
    },
    {
        id: 2,
        title: "Solana Market Cap > Ethereum by 2026?",
        source: "Kalshi",
        long: 31,
        short: 69,
        volume: "528.7M",
        image: "/assets/markets/crypto.png",
        category: "Crypto"
    },
    {
        id: 3,
        title: "US Election 2028: Democrat vs Republican",
        source: "Polymarket",
        long: 53,
        short: 47,
        volume: "584.3M",
        image: "/assets/markets/politics.png",
        category: "Politics"
    },
    {
        id: 4,
        title: "SpaceX Starship Mars Landing 2026?",
        source: "Betfair",
        long: 51,
        short: 49,
        volume: "515.4M",
        image: "/assets/markets/tech.png",
        category: "Tech"
    },
    {
        id: 5,
        title: "OpenAI Releases GPT-6 before Jan 2027?",
        source: "Polymarket",
        long: 87,
        short: 13,
        volume: "511.3M",
        image: "/assets/markets/tech.png",
        category: "Tech"
    },
    {
        id: 6,
        title: "Kansas City Chiefs Win Super Bowl 2026?",
        source: "NFL-SB",
        long: 15,
        short: 85,
        volume: "524.9M",
        image: "/assets/markets/sports.png",
        category: "Sports"
    },
    {
        id: 7,
        title: "Fed Interest Rate Cut > 75bps in 2026?",
        source: "CME Group",
        long: 31,
        short: 69,
        volume: "538.3M",
        image: "/assets/markets/politics.png",
        category: "Finance"
    },
    {
        id: 8,
        title: "Apple Vision Pro 2 Announced < $2000?",
        source: "Polymarket",
        long: 36,
        short: 64,
        volume: "58.3M",
        image: "/assets/markets/tech.png",
        category: "Tech"
    }
];

export const LEADERBOARD_DATA = [
    { rank: 1, name: 'whale.eth', winRate: 92, profit: 1450000, badges: ['👑', '🦄'] },
    { rank: 2, name: 'satoshi_vision.sol', winRate: 88, profit: 980000, badges: ['🚀'] },
    { rank: 3, name: 'alpha_hunter', winRate: 85, profit: 750000, badges: ['🎯'] },
    { rank: 4, name: 'defi_degen.eth', winRate: 81, profit: 620000, badges: [] },
    { rank: 5, name: 'alpha_pro', winRate: 79, profit: 540000, badges: [] },
    { rank: 6, name: 'crypto_king', winRate: 75, profit: 410000, badges: [] },
    { rank: 7, name: 'hodl_gawd', winRate: 72, profit: 320000, badges: [] },
    { rank: 8, name: 'smart_contractor', winRate: 71, profit: 290000, badges: [] },
    { rank: 9, name: 'blockchain_bull', winRate: 69, profit: 265000, badges: [] },
    { rank: 10, name: 'leverage_lord', winRate: 68, profit: 240000, badges: [] },
    { rank: 11, name: 'options_wizard', winRate: 67, profit: 220000, badges: [] },
    { rank: 12, name: 'perpetual_pro', winRate: 66, profit: 205000, badges: [] },
    { rank: 13, name: 'yield_farmer', winRate: 65, profit: 190000, badges: [] },
    { rank: 14, name: 'arbitrage_ace', winRate: 64, profit: 175000, badges: [] },
    { rank: 15, name: 'liquidity_legend', winRate: 63, profit: 160000, badges: [] },
    { rank: 16, name: 'staking_sage', winRate: 62, profit: 148000, badges: [] },
    { rank: 17, name: 'swap_master', winRate: 61, profit: 135000, badges: [] },
    { rank: 18, name: 'dex_ninja', winRate: 60, profit: 122000, badges: [] },
    { rank: 19, name: 'vault_veteran', winRate: 59, profit: 110000, badges: [] },
    { rank: 20, name: 'alpha_pirate', winRate: 58, profit: 98000, badges: [] }
];

export const ROADMAP_DATA = [
    {
        phase: "Q1 2026",
        title: "Launch PredictClaw",
        items: ["Rebrand & UI Overhaul", "Polymarket Integration", "Beta Access"]
    },
    {
        phase: "Q2 2026",
        title: "Lobster Intel Public",
        items: ["Public Prediction Access", "Automated Trading Bots", "Strategy Builder"]
    },
    {
        phase: "Q3 2026",
        title: "Mobile App & DAO",
        items: ["iOS/Android Launch", "Governance Token", "Community Treasury"]
    }
];
